// The signature gold micro-label + the rule-and-label eyebrow pairing.
// Both lean on the base.css classes shared with the production site.
export default function TagLabel({ color, className = '', style, ...rest }) {
  return <span className={`tag-label cn-tag ${className}`.trim()} style={{ color: color || 'var(--accent)', ...style }} {...rest} />
}

export function Eyebrow({ children, className = '', ...rest }) {
  return (
    <div className={`eyebrow ${className}`.trim()} {...rest}>
      <TagLabel>{children}</TagLabel>
    </div>
  )
}
